import { put, select, takeLatest } from 'redux-saga/effects';
import cloneDeep from 'lodash.clonedeep';

import { SET_ELEMENT_CURSOR, setElementCursor as setElementCursorAction } from 'js/actionCreators/cursorActions';
import { updateScribe } from 'js/actionCreators/scribeActions';

import { getScribeById } from './selectors';

export function* setElementCursor({ scribeId, elementIds, cursorId }: ReturnType<typeof setElementCursorAction>) {
  const scribe = (yield select(getScribeById, scribeId)) as ReturnType<typeof getScribeById>;
  if (!scribe) return;

  const elementIdsToFind = Array.isArray(elementIds) ? elementIds : [elementIds];
  const updatedScribe = cloneDeep(scribe);

  const elements = updatedScribe.elements.filter(element => elementIdsToFind.includes(element.id));
  if (!elements.length) return;

  elements.forEach(el => {
    if (el.type === 'Camera') return;
    el.cursorId = cursorId;
  });

  yield put(updateScribe(updatedScribe));
}

export default function* cursorSagas() {
  yield takeLatest(SET_ELEMENT_CURSOR, setElementCursor);
}
